<template>
  <div class="image-less">
    <el-upload
      :action="uploadUrl"
      :on-success="onSuccess"
      :on-remove="onRemove"
      drag
      multiple
      list-type="picture-card"
      :file-list="value"
    >
      <i class="el-icon-plus"></i>
    </el-upload>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: "text"
    }
  },
  data() {
    return {
      fileList: []
    };
  },
  computed: {
    uploadUrl() {
      return process.env.VUE_APP_BASE_API + "/api/upload/imgs";
    }
  },
  methods: {
    onSuccess(response, file, fileList) {
      file.url = response.msg[0];
      this.fileList = fileList.map(x => Object({ url: x.url }));

      this.$emit("input", this.fileList);
    },
    onRemove(file, fileList) {
      this.fileList = fileList.map(x => Object({ url: x.url }));

      this.$emit("input", this.fileList);
    }
  }
};
</script>

<style>
.image-less {
  width: 100%;
}
.image-less .el-upload-dragger {
  height: 100%;
  width: 100%;
}
</style>
